module.exports = __webpack_public_path__ + "img/20200228150803941.dd95f50b.jpg";